import { Component, OnInit } from "@angular/core";
import { ListValueService } from "../core/services/list-value.service";
import { ToastrAlertService } from "../core/services/toastrAlert.service";
import { SweetAlertService } from "../core/services/sweet-alert.service";
import { TokenService } from "../core/services/token.service";
import { TranslateService } from "@ngx-translate/core";
import { MailboxRulesService } from "./mailbox-rules.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-maintenance-mailbox-rules",
  templateUrl: "./maintenance-mailbox-rules.component.html",
  styleUrls: ["./maintenance-mailbox-rules.component.scss"],
})
export class MaintenanceMailboxRulesComponent implements OnInit {
  edited: boolean = false;

  mailboxRule;
  certificatesList = [];
  analistasList = [];
  brandsList = [];

  certificatesCheckedsList = [];
  brandsCheckedList = [];

  analystSelected: string = "";

  allCertificatesSelected: boolean = true;
  allBrandsSelected: boolean = true;

  constructor(
    private listValueService: ListValueService,
    private toastrAlertService: ToastrAlertService,
    private translateService: TranslateService,
    private mailboxRulesService: MailboxRulesService,
    private router: Router,
    private sweetAlertService: SweetAlertService,
    private tokenService: TokenService
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  checkedCertificates(data) {
    this.certificatesList.forEach((element) => {
      let pos;

      pos = data.findIndex((e) => element.tipoCertificado == e.tcertificado);

      if (pos > -1) {
        element.checked = true;
      } else {
        element.checked = false;
        this.allCertificatesSelected = false;
      }
    });
  }

  getCertificatesByAnalyst(analystId: string): void {
    this.mailboxRulesService.getCertificatesByAnalyst(analystId).subscribe(
      (data) => {
        this.allCertificatesSelected = true;
        this.checkedCertificates(data);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  checkedBrands(data) {
    this.brandsList.forEach((element) => {
      let pos = data.findIndex((e) => element.maId == e.rbMarca);
      if (pos > -1) {
        element.checked = true;
      } else {
        element.checked = false;
        this.allBrandsSelected = false;
      }
    });
  }

  getBrandsByAnalyst(analystId: string): void {
    this.mailboxRulesService.getBrandsByAnalyst(analystId).subscribe(
      (data) => {
        this.allBrandsSelected = true;
        this.checkedBrands(data);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getDataByAnalyst() {
    this.getCertificatesByAnalyst(this.analystSelected);
    this.getBrandsByAnalyst(this.analystSelected);
  }

  getAnalysts() {
    this.listValueService.listaAnalistas().subscribe(
      (data) => {
        this.analistasList = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.analystNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getCertificates() {
    this.listValueService.listaSimpleTipoDeDocumento().subscribe(
      (data) => {
        this.certificatesList = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.documentNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getBrands() {
    this.listValueService.listValuesMarcas().subscribe(
      (data) => {
        this.brandsList = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.documentNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }
  getData() {
    this.getAnalysts();
    this.getCertificates();
    this.getBrands();
  }

  selectItem(item) {
    this.edited = true;
    item.checked = item.checked ? false : true;
  }

  selectAllCertificate() {
    this.edited = true;
    if (this.allCertificatesSelected) {
      this.checkedOrUncheckedElements(this.certificatesList, false);
      this.allCertificatesSelected = false;
    } else {
      this.checkedOrUncheckedElements(this.certificatesList, true);
      this.allCertificatesSelected = true;
    }
  }

  selectAllBrands() {
    this.edited = true;
    if (this.allBrandsSelected) {
      this.checkedOrUncheckedElements(this.brandsList, false);
      this.allBrandsSelected = false;
    } else {
      this.checkedOrUncheckedElements(this.brandsList, true);
      this.allBrandsSelected = true;
    }
  }

  checkedOrUncheckedElements(array, value) {
    array.forEach((element) => {
      element.checked = value;
    });
  }

  filterAnddeleteKeyChecked(array): [] {
    let result = array.filter((e) => e.checked == true);
    return result;
  }

  formatCertificates(): any[] {
    let array = this.filterAnddeleteKeyChecked(this.certificatesList);
    let result: any[] = [];
    array.forEach((element) => {
      if (element["tipoCertificado"] == "RE") {
        result.push({
          rbAnalista: this.analystSelected,
          rbMarcoLegal: "N",
          rbReforma: element["tipoReforma"],
          rbTCertificado: element["tipoCertificado"],
        });
      } else {
        result.push({
          rbAnalista: this.analystSelected,
          rbMarcoLegal: "N",
          rbReforma: null,
          rbTCertificado: element["tipoCertificado"],
        });
      }
    });
    return result;
  }

  formatBrands(): string[] {
    let array = this.filterAnddeleteKeyChecked(this.brandsList);
    let result: string[] = [];
    array.forEach((element) => {
      result.push(element["maId"]);
    });
    return result;
  }
  formatDataToSave(): any {
    let arrayCertificates = this.formatCertificates();
    let arrayBrands = this.formatBrands();
    return { arrayCertificates: arrayCertificates, arrayBrands: arrayBrands };
  }

  onSave() {
    let arraysToSave = this.formatDataToSave();
    this.sweetAlertService.sweetAlertLoading();
    this.mailboxRulesService
      .saveMailBoxRule(arraysToSave, this.analystSelected)
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.sweetAlertService.sweetAlertClose();
          this.goPredefinedMailBox();
        },
        (err) => {
          if (err.error != null && err.error.mensaje != null) {
            this.toastrAlertService.toastrFail(err.error.mensaje);
          } else {
            console.log(err);
          }
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  checkedIfAnalystIsValid(analystId: string): boolean {
    let object = this.analistasList.find(
      (item) => item.usuarioId === analystId
    );
    return object ? true : false;
  }

  valueSelector(value) {
    if (this.checkedIfAnalystIsValid(value.item.usuarioId)) {
      this.analystSelected = value.item.usuarioId;
      this.getDataByAnalyst();
    }
  }
  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }
  isPar(i): boolean {
    if (i % 2 == 0) {
      return true;
    } else {
      return false;
    }
  }
}
